<template lang="pug">
  t-dialog(
    v-bind="$attrs"
    :value="isOpened"
    v-on="$listeners"
    :max-width="width"
    @input="close"
  )
    template(
      #icon
      v-if="icon"
    )
      v-img(
        :src="icon.src"
        :max-width="icon.maxWidth"
        class="mb-6"
      )
    template(
      #title
      v-if="title"
    )
      h2(class="title-32px bold ma-0 pa-0") {{ title }}
    template(#content)
      div
        p(
          v-if="text"
          v-html="text"
          class="text-14px light"
        )
        div(
          v-if="showHint"
          class="hint"
        )
          e-svg-icon(
            size="xmd"
            style="vertical-align: -4px"
            class="mr-2"
          ) {{ _.get(hint, 'icon', '') }}
          | {{ hintText }}
    template(#actions)
      div(class="two-buttons-wrapper pt-8")
        v-btn(
          @click="close"
          data-test="confirmation-dialog-cancel-btn"
          height="48"
          :class="buttonsConfig.dismiss.class"
          :loading="rejectLoading"
        )
          | {{ $t(buttonsConfig.dismiss.text) }}
        v-btn(
          @click="confirm"
          data-test="confirmation-dialog-confirm-btn"
          :class="buttonsConfig.approve.class ? buttonsConfig.approve.class : 'secondary-button error-btn'"
          :loading="confirmLoading"
        )
          | {{ $t(buttonsConfig.approve.text) }}
</template>

<script>
import TOrmButtons from '~/components/templates/orm/t-orm-buttons'
import TDialog from '~/components/templates/t-dialog'
import Dialog from '~/models/system/Dialog'
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import responsive from '~/mixins/pages/responsive'

export default {
  components: {
    TOrmButtons,
    TDialog,
    ESvgIcon
  },
  mixins: [responsive],
  props: {
    type: {
      type: String,
      default: 'confirmation'
    }
  },
  data: () => ({
    confirmLoading: false,
    rejectLoading: false
  }),
  computed: {
    dialog() {
      return Dialog.query().where('type', this.type).first()
    },
    isOpened() {
      return this._.get(this.dialog, 'isOpened', false)
    },
    params() {
      return this._.get(this.dialog, 'params', '')
    },
    icon() {
      return this._.get(this.params, 'icon', null)
    },
    title() {
      return this.checkText(this._.get(this.params, 'title', ''))
    },
    text() {
      return this.checkText(this._.get(this.params, 'text', ''))
    },
    hint() {
      return this._.get(this.params, 'hint', '')
    },
    showHint() {
      const visible = this.hint && this._.get(this.hint, 'visible', true)
      return this._.isFunction(visible) ? visible() : visible
    },
    hintText() {
      return this.checkText(this._.get(this.hint, 'text', ''))
    },
    buttonsConfig() {
      const defaultConfig = {
        approve: {
          text: this.$t('Yes'),
          class: 'secondary-button error-btn'
        },
        dismiss: {
          text: this.$t('Cancel')
        }
      }
      return this._.get(this.params, 'buttons', defaultConfig)
    },
    width() {
      return this._.get(this.params, 'width', '500px')
    },
    onConfirm() {
      return this._.get(this.params, 'onConfirm')
    },
    onReject() {
      return this._.get(this.params, 'onReject')
    }
  },
  created() {
    if (!this.dialog) {
      Dialog.insert({
        data: {
          type: this.type
        }
      })
    }
  },
  methods: {
    async close() {
      if (this._.isFunction(this.onReject)) {
        this.rejectLoading = true
        await this.onReject()
        this.rejectLoading = false
      }
      await this.dialog.close(false, true)
    },
    async confirm() {
      if (this._.isFunction(this.onConfirm)) {
        try {
          this.confirmLoading = true
          await this.onConfirm(this)
        } catch (e) {
          this.$handlers.error(e, this)
        } finally {
          this.confirmLoading = false
        }
      }
      await this.dialog.close(true, true)
    },
    checkText(text) {
      return this._.isFunction(text) ? text(this) : this.$t(text)
    }
  }
}
</script>

<style scoped lang="scss">
.hint {
  font-size: 0.75rem;
}
</style>
